/** Aligné sur `api/disputeEligibility.js` : pas de litige après constat plateforme (détournement / harvest). */
export const OPEN_DISPUTE_BLOCKED_PLATFORM_DETAIL_FR =
  "Sur cette transaction, la plateforme a constaté un détournement ou une récupération de coordonnées interdite. L’ouverture d’un litige n’est pas possible ; pour toute question, contactez le support.";

function getAiAnalysisBlob(rowOrAnalysis) {
  if (!rowOrAnalysis || typeof rowOrAnalysis !== "object") return null;
  const inner = rowOrAnalysis.ai_analysis;
  if (inner && typeof inner === "object") return inner;
  return rowOrAnalysis;
}

export function isDisputeOpeningBlockedByPlatform(rowOrAnalysis) {
  const a = getAiAnalysisBlob(rowOrAnalysis);
  if (!a || typeof a !== "object") return false;
  if (String(a.platform_rule_violation || "").toLowerCase().trim() === "contact_harvesting") return true;
  if (a.diversion_detected === true) return true;
  return false;
}
